/**
 * @namespace Stores
 * @category Stores
 * @module nearby-items
 */

const createState = () => ({
  nearbyVehiclesRadius: 0,
  nearbyEventsRadius: 0,
  nearbyEventsTimeFrame: 'placeholder',
  loading: false,
  selectedNearbyVehicle: null,
  selectedNearbyEvent: null,
  nearbyVehicleItems: [],
  nearbyEventItems: [],
  disableSelectListeners: false,
  selectedNearbyEventDisabled: false,
})

export default {
  namespaced: true,
  state: createState(),
  getters: {
    isNearbyVehiclesFormDisabled: (state) => !!state.nearbyEventsRadius,
    isNearbyEventsFormDisabled: (state) => !!state.nearbyVehiclesRadius,
    isPreviewButtonDisabled: (state) => {
      // Check if both radii are 0
      if (state.nearbyVehiclesRadius === 0 && state.nearbyEventsRadius === 0) {
        return true
      }

      // Check individual invalid states
      const isInvalidVehiclesRadius =
        state.nearbyVehiclesRadius == null || // Null/undefined check
        state.nearbyVehiclesRadius <= 0 || // Negative values are invalid
        state.nearbyVehiclesRadius > 1000 || // Exceeds max limit
        typeof state.nearbyVehiclesRadius !== 'number'

      const isInvalidEventsRadius =
        state.nearbyEventsRadius == null || // Null/undefined check
        state.nearbyEventsRadius <= 0 || // Negative values are invalid
        state.nearbyEventsRadius > 1000 || // Exceeds max limit
        typeof state.nearbyEventsRadius !== 'number'

      const isInvalidTimeFrame =
        state.nearbyEventsTimeFrame == null ||
        typeof state.nearbyEventsTimeFrame !== 'number' ||
        isNaN(state.nearbyEventsTimeFrame)

      if (isInvalidVehiclesRadius && state.nearbyEventsRadius === 0) {
        return true
      }

      // 2. Events radius is invalid and vehicles radius is 0 (no matter the time frame)
      if (isInvalidEventsRadius && state.nearbyVehiclesRadius === 0) {
        return true
      }

      // 4. Events radius is valid but time frame is invalid (button is disabled)
      if (!isInvalidEventsRadius && isInvalidTimeFrame) {
        return true
      }

      // Enable the button if:
      // 3. Vehicles radius is valid (no matter the events radius or time frame)
      if (!isInvalidVehiclesRadius) {
        return false
      }

      // 5. Events radius and time frame are valid (button is enabled)
      if (!isInvalidEventsRadius && !isInvalidTimeFrame) {
        return false
      }

      // Default case: disabled
      return true
    },
    currentMode: (state, getters) => {
      if (
        getters.isNearbyVehiclesFormDisabled &&
        !getters.isPreviewButtonDisabled
      ) {
        return 'nearby_events'
      }

      if (
        getters.isNearbyEventsFormDisabled &&
        !getters.isPreviewButtonDisabled
      ) {
        return 'nearby_vehicles'
      }

      return ''
    },
    selectedNearbyVehicle: (state) => state.selectedNearbyVehicle,
    selectedNearbyEvent: (state) => state.selectedNearbyEvent,
    nearbyVehicleItems: (state) => state.nearbyVehicleItems,
    nearbyEventItems: (state) => state.nearbyEventItems,
  },
  mutations: {
    // Update a single state value
    updateState(state, { key, value }) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        state[key] = value
      } else {
        console.warn(`Invalid state key: "${key}"`)
      }
    },
    // Reset the state to its initial values
    resetState(state) {
      Object.assign(state, createState())
    },
  },
}
